export default __webpack_public_path__ + "static/media/attachment.8d058e8f.svg";